import React from 'react'
import { connect } from 'react-redux'
// import Loading from '../Shared/Loading'
import LoadingBar from '../Shared/LoadingBar'
// import { Line } from 'rc-progress'
import { movieService } from '../../_services/movie.service'
// import "react-circular-progressbar/dist/styles.css"
// import NumberFormat from 'react-number-format'
import { FaPlay } from 'react-icons/fa'
import ReactPlayer from 'react-player'
import scrollToComponent from 'react-scroll-to-component'
import { AiOutlineLoading } from 'react-icons/ai'

class MembersDashboard extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      loading: true,
      data: [],
      selected: '',
      key: 0
    }
  }

  componentWillMount = () => {
    LoadingBar(true)

    this.getData()
  }

  getData() {
    movieService
      .getAll()
      .then(res => {
        // console.log(res.data)
        var data = res.data
        this.setState({ data: data, loading: false }, () => {
          LoadingBar(false)
        })
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleError(error) {
    this.setState({ loading: false })
    LoadingBar(false)
    // console.log(error);
  }

  handleMovieSelect = item => {
    this.setState({ selected: item, key: this.state.key + 1 }, () => {
      scrollToComponent(this.refs.playerContainer)
    })
  }

  render() {
    const { data, selected, loading } = this.state
    return (
      <div className="movies">
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <div
              className="player-container"
              ref={section => {
                this.playerContainer = section
              }}>
              {selected ? (
                <>
                  <ReactPlayer
                    key={this.state.key}
                    url={selected && selected.moviePath}
                    light={selected && selected.imagePath}
                    playing
                    config={{
                      file: {
                        attributes: {
                          controlsList: 'nodownload'
                        }
                      }
                    }}
                    width="100%"
                    // height="100%"
                    controls
                  />
                  <h4>{selected && selected.name}</h4>
                </>
              ) : (
                <h6>لطفا فیلم مورد نظر خود را از لیست زیر انتخاب کنید</h6>
              )}
            </div>
          </div>
        </div>

        {loading ? (
          <div className="loading-container">
            <AiOutlineLoading
              className="mdi-spin"
              size="32px"
              color="#5079f7"
            />
          </div>
        ) : (
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              {data &&
                data.map((item, index) => (
                  <ul key={'title-' + item.id} className="movies-titles">
                    <li>
                      <h4>{item.name}</h4>
                      {item.movies && (
                        <ul className="movies-list">
                          {item.movies.map((movie, mIndex) => (
                            <li
                              key={'movie-' + movie.id}
                              className={
                                selected && selected.id === movie.id
                                  ? 'movie-item selected'
                                  : 'movie-item'
                              }>
                              <div>{movie.name}</div>
                              <div>
                                <h5>{movie.duration}</h5>
                                <a
                                  className="btn btn-play"
                                  onClick={() => this.handleMovieSelect(movie)}>
                                  <FaPlay color="#fff" size="24px" />
                                </a>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  </ul>
                ))}
            </div>
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { users, authentication } = state
  const { user } = authentication
  return {
    user,
    users
  }
}

const connectedMembersDashboard = connect(mapStateToProps)(MembersDashboard)
export { connectedMembersDashboard as MembersDashboard }
